<template>
  <v-row class="flex-nowrap" dense>
    <v-menu
      ref="datePicker"
      :close-on-content-click="false"
      v-model="dateDialog"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
      :disabled="readonly === true"
    >
      <template #activator="{on}">
        <v-text-field
          v-on="on"
          v-model="dateTime"
          :placeholder="placeholder"
          :label="label"
          prepend-icon=""
          :error-messages="dateTimeValidation"
          readonly
          :clearable="clearable"
        />
      </template>
      <v-date-picker v-model="date" no-title scrollable @input="$refs.datePicker.save(date)" first-day-of-week="1" :locale="locale" />
    </v-menu>
    <v-menu
      ref="timePicker"
      :close-on-content-click="false"
      v-model="timeDialog"
      :nudge-right="40"
      :return-value.sync="time"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template #activator="{on}">
        <span v-on="on" />
      </template>
      <v-time-picker v-model="time" @click:minute="$refs.timePicker.save(time)" format="24hr" :locale="locale" />
    </v-menu>
    <span v-if="defaultButton && !readonly">
      <v-tooltip :disabled="buttonTooltip == null" bottom>
        <template #activator="{on}">
          <v-btn :disabled="buttonDisabled" @click="setDefaultValue" text icon v-on="on" class="mt-5">
            <v-icon>{{ buttonIcon }}</v-icon>
          </v-btn>
        </template>
        {{ buttonTooltip }}
      </v-tooltip>
    </span>
  </v-row>
</template>

<script>
export default {
  name: "DateTimePickerComputed",
  props: {
    readonly: {
      required: false,
      default: false
    },
    dateTimeModel: {
      required: true
    },
    label: {
      required: false,
      default: false
    },
    dateTimeValidation: {
      type: Array,
      required: false,
      default: () => []
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    defaultButton: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultValue: {
      required: false
    },
    buttonTooltip: {
      default: null
    },
    buttonIcon: {
      default: "keyboard_return"
    },
    buttonDisabled: {
      default: false
    },
    clearable: {
      default: false
    }
  },
  data: () => ({
    dateDialog: false,
    timeDialog: false,
    model: "",
    validationError: false,
    validationMessage: []
  }),
  watch: {
    dateDialog: function(oldModel, newModel) {
      if (newModel === true) {
        this.timeDialog = true;
      }
    }
  },
  methods: {
    minutesLimit: v => !(v % 5 !== 0),
    addZeroBefore: function(n) {
      return (n < 10 ? "0" : "") + n;
    },
    setDefaultValue() {
      this.dateTime = this.defaultValue;
    }
  },
  computed: {
    contextLabel() {
      if (this.label === false) {
        return this.$t("global.dateTime");
      }
      return this.label;
    },
    date: {
      set: function(value) {
        if (this.dateTime != null && this.dateTime.length > 1) {
          const dateTime = this.dateTime.split(" ");
          if (dateTime.length > 1) {
            this.dateTime = value + " " + dateTime[1];
            return this.dateTime;
          }
        }
        this.dateTime = value + " ";
      },
      get: function() {
        if (this.dateTime != null && this.dateTime.length > 1) {
          const dateTime = this.dateTime.split(" ");
          if (dateTime.length > 1) {
            return dateTime[0];
          }
        }
        return null;
      }
    },
    time: {
      set: function(value) {
        if (this.dateTime != null && this.dateTime.length > 1) {
          const dateTime = this.dateTime.split(" ");
          if (dateTime.length > 1) {
            this.dateTime = dateTime[0] + " " + (value != null ? value : "");
            return value;
          }
        }
        this.dateTime = value;
      },
      get: function() {
        if (this.dateTime != null && this.dateTime.length > 1) {
          const dateTime = this.dateTime.split(" ");
          if (dateTime.length > 1) {
            if (dateTime[1].length < 5) return null;
            return dateTime[1];
          }
        }
        return null;
      }
    },
    dateTime: {
      set: function(value) {
        this.$emit("update:dateTimeModel", value);
      },
      get: function() {
        return this.dateTimeModel;
      }
    },
    locale() {
      return this.$i18n.locale;
    }
  }
};
</script>

<style scoped></style>
